module.exports = __webpack_public_path__ + "img/kz.80322b92.svg";